import AppLoader from '@/components/AppLoader';
import HeaderTemplate from '@/templates/Header.template';
import { Box, Button, Container, Heading } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import CreateTeamModal from './components/create-team/create-team.modal';
import NoTeamsBanner from './components/no-teams.component';
import TeamList from './components/team-list/team-list.view';
import { useTeamsPage } from './teams.controller';

export default function TeamsPage() {
	const { t, modalDisclosure, query } = useTeamsPage();

	if (!query.data) {
		return <AppLoader />;
	}

	return (
		<Container maxW="container.md" padding="0" h="full" overflow="auto" display="grid" gridTemplateRows="auto 1fr">
			<HeaderTemplate
				left={<CreateTeamModal close={() => modalDisclosure.onClose()} isOpen={modalDisclosure.isOpen} />}
				center={
					<Heading textAlign="center" size="sm">
						{t('Teams')}
					</Heading>
				}
				right={
					<Button colorScheme="primary" size="sm" onClick={() => modalDisclosure.onOpen()} leftIcon={<FiPlus />}>
						{t('New team')}
					</Button>
				}
			/>
			<Box mt={4}>
				{query.data.organizations.length > 0 ? <TeamList organizations={query.data.organizations} /> : <NoTeamsBanner />}
			</Box>
		</Container>
	);
}
